import Vue from "vue";

const templateId = +document.body.getAttribute("data-tplId") || +document.body.getAttribute("tplid");
const templatePath = "./templates/" + templateId + "/firstfindblock.js";

let component = Vue.component("firstfindblock", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['jsonval', 'findVal'],
      mounted() {
        const urlParams = new URLSearchParams(window.location.search)
        this.one = urlParams.get("findtext") || ''
        this.mintwo = urlParams.get("price_before_new") || ''
        this.maxtwo = urlParams.get("price_after_new") || ''
        let status = urlParams.get("item_status")
        let old = urlParams.get("discount")
        this.three = status ? [status] : []
        this.isSale = old ? [old] : []
      },
      data() {
        return {
          one:'',
          mintwo:'',
          maxtwo:'',
          three:[],
          isSale:[],
          labelclasstrue: 'ok-form-label -state-active',
          labelclassfalse: 'ok-form-label',
          isoneLabel:false,
          istwoLabel:false,
          isthreeLabel:false,
          urlValue: ''
        }
      },
      watch: {
        mintwo() {
          if (this.mintwo==='' && this.maxtwo==='') {
            this.istwoLabel=false;
          } else {
            this.istwoLabel=true;}
        },
        maxtwo() {
          if (this.maxtwo==='' && this.mintwo==='') {
            this.istwoLabel=false;
          } else {
            this.istwoLabel=true;}
        },
        one() {
          if (this.one==='') {
            return this.isoneLabel=false;
          } else {
            this.isoneLabel=true;}
        },
        three() {
          if (this.three.length===0) {
            this.isthreeLabel=false
          } else {
            this.isthreeLabel=true;
          }
        }
      }
    });
  });
});
export default component;
